var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBnb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 71,
    viewBox: "0 0 70 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.2543 35.5207C69.2543 54.6447 53.7512 70.1478 34.6271 70.1478C15.5031 70.1478 0 54.6447 0 35.5207C0 16.3967 15.5031 0.893555 34.6271 0.893555C53.7512 0.893555 69.2543 16.3967 69.2543 35.5207Z",
    fill: "#4B5158"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5441_6959)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.558 32.8972L34.6278 24.8274L42.7014 32.9007L47.3968 28.2053L34.6278 15.4365L21.8629 28.2015L26.5581 32.8969L26.558 32.8972ZM13.8516 36.2128L18.5471 31.5165L23.2424 36.2118L18.5468 40.9074L13.8516 36.2128ZM26.558 39.5289L34.6278 47.5982L42.7012 39.525L47.3991 44.218L47.3968 44.2205L34.6278 56.9891L21.8629 44.2241L21.8562 44.2175L26.5584 39.5284L26.558 39.5289ZM46.0131 36.2148L50.7087 31.5192L55.404 36.2145L50.7085 40.9101L46.0131 36.2148Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3897 36.2109H39.3917L34.6274 31.4463L31.1059 34.9668L30.7014 35.3715L29.867 36.2061L29.8604 36.2125L29.867 36.2194L34.6274 40.9804L39.392 36.2159L39.3943 36.2132L39.39 36.2109",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5441_6959"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41.5526,
    height: 41.5526,
    fill: "white",
    transform: "translate(13.8516 15.4365)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBnb);
export default __webpack_public_path__ + "static/media/bnb.5da58a9b052053c85ce65fe0d0161c58.svg";
export { ForwardRef as ReactComponent };